import tryIt from "../../../assets/images/magicPen/tryIt.png";
import tryItMagicPen from "../../../assets/images/magicPen/tryItMagicPen.png";
import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";

export default function TryItCard({ onClick }: { onClick: () => void }) {
  return (
    <Touchable
      className="relative h-[96px] w-[200px] overflow-hidden rounded-lg bg-white p-1.5 shadow tablet:h-[130px] tablet:w-[272px]"
      onClick={onClick}
    >
      <img
        src={tryIt}
        alt="try it"
        className="h-[84px] w-[120px] tablet:h-[113px] tablet:w-[163px]"
      />

      <img
        src={tryItMagicPen}
        alt="mickey pen"
        className="back-and-forth-sway absolute right-[42px] top-[3px] w-12 tablet:right-16 tablet:top-1 tablet:w-16"
      />

      <Text lg className="absolute bottom-4 right-3 font-medium">
        Try it
      </Text>
    </Touchable>
  );
}
